import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import BigCalendar from 'react-big-calendar'
import moment from 'moment'
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as Actions from './store/actions';
import * as paramActions from '../../components/paramHistory/store/actions';
import {
    Button, 
    Icon, 
    Grid, 
    Card, 
    Divider, 
    AppBar, 
    Typography, 
    IconButton, 
    TextField, 
    CardContent, 
    CardActions,
} from '@material-ui/core';
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop'
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';
import OrderedSchedule from './ScheduleComponents/OrderedSchedule';
import Container from './ScheduleComponents/Container';
import EventChip from './ScheduleComponents/EventChip';
import { withRouter } from 'react-router-dom';
import EventList from './ScheduleComponents/EventList';

BigCalendar.setLocalizer(BigCalendar.momentLocalizer(moment));

const DragAndDropCalendar = withDragAndDrop(BigCalendar, { backend: false });

const allViews = ["day"]

const styles = theme => ({
    calendarCardHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems:  'center',
        paddingLeft: '5px',
        paddingRight: '5px',
    },
    calendarCardContent: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    root: {
        display: 'flex',
        position: 'relative',
        flexDirection: 'column',
        flex: 1,
        '& .rbc-header': {
            padding: '12px 6px',
            fontWeight: 500,
            fontSize: 14

        },
        '& .rbc-label': {
            padding: '8px 6px'
        },
        '& .rbc-today': {
            backgroundColor: 'transparent'
        },
        '& .rbc-header.rbc-today, & .rbc-month-view .rbc-day-bg.rbc-today': {
            borderBottom: '2px solid ' + theme.palette.secondary.main + '!important'
        },
        '& .rbc-month-view, & .rbc-time-view, & .rbc-agenda-view': {
            padding: 24,
            ...theme.mixins.border(0)
        },
        '& .rbc-agenda-view table': {
            ...theme.mixins.border(1),
            '& thead > tr > th': {
                ...theme.mixins.borderBottom(0)
            },
            '& tbody > tr > td': {
                padding: '12px 6px',
                '& + td': {
                    ...theme.mixins.borderLeft(1)
                }
            }
        },
        '& .rbc-time-view': {
            '& .rbc-time-header': {
                // ...theme.mixins.border(1)
                display: 'none'
            },
            '& .rbc-time-content': {
                flex: '0 1 auto',
                ...theme.mixins.border(1)
            }
        },
        '& .rbc-month-view': {
            '& > .rbc-row': {
                ...theme.mixins.border(1)
            },
            '& .rbc-month-row': {
                ...theme.mixins.border(1),
                borderWidth: '0 1px 1px 1px!important',
                minHeight: 128
            },
            '& .rbc-header + .rbc-header': {
                ...theme.mixins.borderLeft(1)
            },
            '& .rbc-header': {
                ...theme.mixins.borderBottom(0)
            },
            '& .rbc-day-bg + .rbc-day-bg': {
                ...theme.mixins.borderLeft(1)
            }
        },
        '& .rbc-day-slot .rbc-time-slot': {
            ...theme.mixins.borderTop(1),
            opacity: 0.5,
        },
        '& .rbc-time-header > .rbc-row > * + *': {
            ...theme.mixins.borderLeft(1)
        },
        '& .rbc-time-content > * + * > *': {
            ...theme.mixins.borderLeft(1)
        },
        '& .rbc-day-bg + .rbc-day-bg': {
            ...theme.mixins.borderLeft(1)
        },
        '& .rbc-time-header > .rbc-row:first-child': {
            ...theme.mixins.borderBottom(1)
        },
        '& .rbc-timeslot-group': {
            minHeight: 64,
            ...theme.mixins.borderBottom(1)
        },
        '& .rbc-date-cell': {
            padding: 8,
            fontSize: 16,
            fontWeight: 400,
            opacity: .5,
            '& > a': {
                color: 'inherit'
            }
        },
        '& .rbc-event': {
            borderRadius: 0,
            // padding: '4px 8px',
            backgroundColor: theme.palette.primary.dark,
            minHeight: '30px',
            color: theme.palette.primary.contrastText,
            boxShadow: theme.shadows[0],
            transitionProperty: 'box-shadow',
            transitionDuration: theme.transitions.duration.short,
            transitionTimingFunction: theme.transitions.easing.easeInOut,
            position: 'relative',
            '&:hover': {
                boxShadow: theme.shadows[2]
            }
        },
        //Connor
        '& .rbc-event-label': {
            display: 'none'
        },
        '& .rbc-day-slot .rbc-event': {
            minHeight: '30px'
        },
        '& .rbc-row-segment': {
            padding: '0 4px 4px 4px'
        },
        '& .rbc-off-range-bg': {
            backgroundColor: theme.palette.type === 'light' ? 'rgba(0,0,0,0.03)' : 'rgba(0,0,0,0.16)'
        },
        '& .rbc-show-more': {
            color: theme.palette.secondary.main,
            background: 'transparent'
        },
        '& .rbc-addons-dnd .rbc-addons-dnd-resizable-month-event': {
            position: 'static'
        },
        '& .rbc-addons-dnd .rbc-addons-dnd-resizable-month-event .rbc-addons-dnd-resize-month-event-anchor:first-child': {
            left: 0,
            top: 0,
            bottom: 0,
            height: 'auto'
        },
        '& .rbc-addons-dnd .rbc-addons-dnd-resizable-month-event .rbc-addons-dnd-resize-month-event-anchor:last-child': {
            right: 0,
            top: 0,
            bottom: 0,
            height: 'auto'
        },
        '& .rbc-toolbar-label': {
            display: 'none'
        },
        '& .rbc-btn-group': {
            display: 'none'
        }
    }
});

class LessonSchedule extends Component {

    moveEvent = ({ event, start, end }) => {
        this.props.eventAddChecker(event)
        this.props.updateEvent({
            event,
            start,
            end
        });
    };

    resizeEvent = (resizeType, { event, start, end }) => {
        delete event.type;
        this.props.updateEvent({
            event,
            start,
            end
        });
    };

    eventStyleGetter = (event, start, end, isSelected) => {
        switch (event.eventType) {
            case ('assignment'): {
                let style = { backgroundColor: event.selected ? '#3D9970' : event.Color, color: this.props.theme.palette.getContrastText(event.Color) }
                return { style: style }
            }
            case ('quiz'): {
                let style = { backgroundColor: event.selected ? '#B10DC9' : '#0074D9' }
                return { style: style }
            }
        }
    }

    render() {
        const { classes, events, leftItemsAssignment, leftItemsQuiz, unscheduledEvents } = this.props;

        const dayComponent = ({ event }) => (
            <div>
                <Grid container spacing={0}>
                    <Grid item xs={12} className={classes.calendarCardHeader}>
                        <Typography>{moment(event.start).format('h:mm A')} - {moment(event.end).format('h:mm A')}</Typography>
                        <IconButton
                            style={{ padding: '0px', margin: '0px' }}
                            onClick={() => this.props.removeEventFromCalendar(event)}
                        >
                            <Icon>delete</Icon>
                        </IconButton>
                    </Grid>
                    <Grid item xs={12} className={classes.calendarCardContent}>
                        <Typography>{event.title}</Typography>
                    </Grid>
                </Grid>
            </div>
        )

        return (
            <div className={classes.root}>
                <Grid container spacing={24}>
                    <Grid item xs={6}>
                        <Card>
                            <EventList
                                leftItemsAssignment={leftItemsAssignment}
                                leftItemsQuiz={leftItemsQuiz}
                                unscheduledEvents={unscheduledEvents}
                                removeEventFromCalendar={this.props.removeEventFromCalendar}
                                onClickEvent={this.props.onClickEvent}
                                isUnscheduled={false}
                                currentLesson={this.props.currentLesson}
                                auth_id={this.props.auth_id}
                                companies={this.props.companies}
                            />
                        </Card>
                    </Grid>

                    <Grid item xs={6}>
                        <Card>
                            <AppBar position="static">
                                <div className="p-16 pr-4 flex flex-row items-center justify-between">
                                    <Typography className="h3 pr-16" color="inherit">Calendar</Typography>
                                </div>
                            </AppBar>
                            <DragAndDropCalendar
                                selectable
                                onEventDrop={this.moveEvent}
                                resizable
                                onEventResize={this.resizeEvent}
                                className="flex flex-1"
                                events={events}
                                views={allViews}
                                step={30}
                                showMultiDayTimes
                                defaultDate={new Date(2018, 9, 1)}
                                components={{
                                    toolbar: 'none'
                                }}
                                components={{ day: { event: dayComponent } }}
                                defaultView="day"
                                min={new Date(moment().startOf('day').add(6, 'hours'))}
                                max={new Date(moment().startOf('day').add(18, 'hours'))}
                                eventPropGetter={(this.eventStyleGetter)}
                            />
                        </Card>
                    </Grid>
                </Grid>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        dropToCalendar: Actions.checkAssignmentEventAdd,
        updateParams: paramActions.updateCourseBuilderParams,
        saveLesson: Actions.saveLesson,

    }, dispatch);
}

function mapStateToProps({ calendarApp, }) {
    return {
    }
}

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(LessonSchedule)));


// WEBPACK FOOTER //
// src/main/content/lesson/LessonSchedule.js